import styled from 'styled-components'
import { Link } from 'components/UI/Link'
import { LinkProps as RouterLinkProps } from 'react-router-dom'
interface TRProps {
  isLast?: boolean
}

export const HoverBlock = styled.div`
  height: 0;
  width: 100%;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s linear, visibility 0s;
`

export const TR = styled.div<TRProps>`
  display: flex;
  align-items: center;
  //border-radius: 8px;
  padding: 1rem;
  background-color: #ffffff;
  //box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  min-height: 70px;
  transition: flex 0.3s ease-out;
  height: auto;
  margin-bottom: 1px;
  border-bottom-left-radius: ${props => (props.isLast ? '8px' : '')};
  border-bottom-right-radius: ${props => (props.isLast ? '8px' : '')};
  // :hover {
  //   ${HoverBlock} {
  //     display: flex;
  //     visibility: visible;
  //     height: auto;
  //     opacity: 1;
  //     margin-top: 1rem;
  //   }
  }
`

export const TD = styled.div`
  flex: 1 1 20%;
  color: #585d64;
  font-size: 14px;
  font-weight: 600;
  padding: 0 0.5rem 0 0;
`

export const MainSection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const InfoLink = styled(Link)<RouterLinkProps>`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  text-decoration: none;
`

export const Actions = styled.div`
  margin-left: auto;
  width: 2.5rem;
`

export const EstimatedItem = styled(TD)`
  margin-left: auto;
  width: 2.5rem;
  padding-left: 1rem;
`
